import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import { LegacyLink } from './LegacyLink';
import { SimpleLink } from './SimpleLink';
var deprecatedProps = ['chronicle', 'color', 'decorated', 'italic', 'unstyled', 'uppercase'];

/**
 * To keep styles simple while also retaining backwards compatibility, this
 * component has been bifurcated into two internal components: `<SimpleLink>`
 * and `<LegacyLink>`. If no deprecated props are used, `<SimpleLink>` will be
 * rendered. Otherwise, `<LegacyLink>` will be used instead.
 *
 * During the next major version bump, `<LegacyLink>` should be removed and
 * `<SimpleLink>` should become the implementation of `<Link>`.
 */
export var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  useDeprecatedPropsWarning({
    component: 'Link',
    deprecatedProps: [{
      deprecated: 'chronicle',
      migration: 'Designers should not be using Chronicle in links. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'color',
      migration: 'All links should appear as default blue. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'decorated',
      migration: 'All links should appear as default blue at this time, so underline is not needed. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'italic',
      migration: 'Designers should not be using italic in links. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'uppercase',
      migration: 'All links should appear Body, Body Small or Legal at this time. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }, {
      deprecated: 'unstyled',
      migration: 'All links should appear as default blue. Slack #design-system with your use case and to get help!',
      version: '1.7.0'
    }],
    props: props
  });
  var needsLegacyLink = deprecatedProps.some(function (deprecatedProp) {
    return !!props[deprecatedProp];
  });

  if (needsLegacyLink) {
    return /*#__PURE__*/React.createElement(LegacyLink, _extends({}, props, {
      ref: ref
    }));
  }

  return /*#__PURE__*/React.createElement(SimpleLink, _extends({}, props, {
    ref: ref
  }));
});
var validSizes = [0, 1, 2, 3, 4, 5];
var linkLevelSizeMap = {
  small: 1,
  legal: '0'
};
Link.displayName = 'Link';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require -- directive added automatically by Shepherd migration
  var PropTypes = require('prop-types');

  Link.propTypes = {
    /** Applies bold styling. */
    bold: PropTypes.bool,

    /** Children string or components to render between <span>, or in place of <span>. */
    children: PropTypes.node,
    className: PropTypes.string,

    /**
     * Allows you to provide a React component or other HTML element,
     * overriding the default `a` and `button` options.
     */
    component: PropTypes.any,
    // eslint-disable-line react/forbid-prop-types

    /**
     * Whether or not to apply disabled styles. Note that this should only be
     * used when this component is rendering a `button`.
     */
    disabled: PropTypes.bool,
    gotham: PropTypes.bool,

    /** The URL to visit. */
    href: PropTypes.string,

    /**
     * Size of the link. Supports semantic "small" and "legal" or a numeric
     * scale from size 0 to 5.
     */
    size: PropTypes.oneOf([].concat(validSizes, _toConsumableArray(Object.keys(linkLevelSizeMap)))),

    /** Force the component to use its hover styles. */
    dangerouslyForceHoverStyling: PropTypes.bool,

    /** Force the component to use its focus styles. */
    dangerouslyForceFocusStyling: PropTypes.bool,

    /** Force the component to use its click or active styles. */
    dangerouslyForceActiveStyling: PropTypes.bool
  };
}